import React from 'react';
export const extractKeyFromKey = (key) => (item) => String(item[key]);
export const renderItem = (Comp, propsObj = {}) => ({ item, index }) => <Comp {...item} index={index} {...propsObj}/>;
